<template>
        <div class="layui-form-select">
            <div class="layui-select-title" @click.stop="decideShowSelect()">
                <input type="text" placeholder="--请选择--" v-model="title" class="layui-input" disabled :class="{'layui-disabled' : !enabled}">
                <i class="layui-edge"></i>
            </div>
            <div class="layui-anim layui-anim-upbit layuitreeselect-items">
                <div 
                    :lay-value="treeItem1.value"                   
                    v-for="treeItem1 in data"  
                    v-bind:key="treeItem1.id"
                    @click.stop="select(treeItem1)">
                    <div :class="{'layui-this': treeItem1 == selectRow}" class="layuitreeselect-item" style="padding-left: 20px;">
                            <span class="layui-tree-iconClick " :class="{'layui-tree-icon' : !treeItem1.isLeaf}" @click.stop="expand(treeItem1)">
                            <i class="layui-icon" style="position:initial" :class="{'layui-icon-subtraction' : (treeItem1.expand && !treeItem1.isLeaf), ' layui-icon-addition': (!treeItem1.expand && !treeItem1.isLeaf), 'layui-icon-file': treeItem1.isLeaf}"></i>
                        </span>
                        <div  :class="{'layui-form-checked': treeItem1.checked}" class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck" @click.stop="check(treeItem1)">
                            <i class="layui-icon layui-icon-ok"  ></i>
                        </div>
                        <span class="tree-text" v-text="treeItem1.title" ></span>
                    </div>
                    <div
                        v-show = "treeItem1.expand" 
                        :lay-value="treeItem2.value"
                        v-for="treeItem2 in treeItem1.children"  
                        v-bind:key="treeItem2.id"
                        @click.stop="select(treeItem2)" >
                        <div :class="{'layui-this': treeItem2 == selectRow}" class="layuitreeselect-item"  style="padding-left: 40px;">
                                <span class="layui-tree-iconClick " :class="{'layui-tree-icon' : !treeItem2.isLeaf}" @click.stop="expand(treeItem2)">
                                <i class="layui-icon" style="position:initial" :class="{'layui-icon-subtraction' : (treeItem2.expand && !treeItem2.isLeaf), ' layui-icon-addition': (!treeItem2.expand && !treeItem2.isLeaf), 'layui-icon-file': treeItem2.isLeaf}"></i>
                            </span>
                            <div class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck"  @click.stop="check(treeItem2)" :class="{'layui-form-checked': treeItem2.checked}">
                                <i class="layui-icon layui-icon-ok"></i>
                            </div>
                            <span class="tree-text" v-text="treeItem2.title" ></span>
                        </div>
                        <div
                            v-show = "treeItem2.expand" 
                            :lay-value="treeItem3.value"
                            v-for="treeItem3 in treeItem2.children"  
                            v-bind:key="treeItem3.id"
                            @click.stop="select(treeItem3)" >
                            <div :class="{'layui-this': treeItem3 == selectRow}" class="layuitreeselect-item" style="padding-left: 60px;">
                                    <span class="layui-tree-iconClick " :class="{'layui-tree-icon' : !treeItem3.isLeaf}" @click.stop="expand(treeItem3)">
                                    <i class="layui-icon" style="position:initial" :class="{'layui-icon-subtraction' : (treeItem3.expand && !treeItem3.isLeaf), ' layui-icon-addition': (!treeItem3.expand && !treeItem3.isLeaf), 'layui-icon-file': treeItem3.isLeaf}"></i>
                                </span>
                                <div class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck"  @click.stop="check(treeItem3)" :class="{'layui-form-checked': treeItem3.checked}">
                                    <i class="layui-icon layui-icon-ok"></i>
                                </div>
                                <span class="tree-text" v-text="treeItem3.title" ></span>
                            </div>

                            <div
                                v-show = "treeItem3.expand" 
                                :lay-value="treeItem4.value"
                                v-for="treeItem4 in treeItem3.children"  
                                v-bind:key="treeItem4.id"
                                @click.stop="select(treeItem4)" >
                                <div :class="{'layui-this': treeItem4 == selectRow}" class="layuitreeselect-item" style="padding-left: 80px;">
                                        <span class="layui-tree-iconClick " :class="{'layui-tree-icon' : !treeItem4.isLeaf}" @click.stop="expand(treeItem4)">
                                        <i class="layui-icon" style="position:initial" :class="{'layui-icon-subtraction' : (treeItem4.expand && !treeItem4.isLeaf), ' layui-icon-addition': (!treeItem4.expand && !treeItem4.isLeaf), 'layui-icon-file': treeItem4.isLeaf}"></i>
                                    </span>
                                    <div class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck"   @click.stop="check(treeItem4)" :class="{'layui-form-checked': treeItem4.checked}">
                                        <i class="layui-icon layui-icon-ok"></i>
                                    </div>
                                    <span class="tree-text" v-text="treeItem4.title" ></span>
                                </div>

                                <div
                                    v-show = "treeItem4.expand" 
                                    :lay-value="treeItem5.value"
                                    v-for="treeItem5 in treeItem4.children"  
                                    v-bind:key="treeItem5.id"
                                    @click.stop="select(treeItem5)" >
                                    <div :class="{'layui-this': treeItem5 == selectRow}" class="layuitreeselect-item" style="padding-left: 100px;">
                                            <span class="layui-tree-iconClick " :class="{'layui-tree-icon' : !treeItem5.isLeaf}" @click.stop="expand(treeItem5)">
                                            <i class="layui-icon" style="position:initial" :class="{'layui-icon-subtraction' : (treeItem5.expand && !treeItem5.isLeaf), ' layui-icon-addition': (!treeItem5.expand && !treeItem5.isLeaf), 'layui-icon-file': treeItem5.isLeaf}"></i>
                                        </span>
                                        <div class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck"   @click.stop="check(treeItem5)" :class="{'layui-form-checked': treeItem5.checked}">
                                            <i class="layui-icon layui-icon-ok"></i>
                                        </div>
                                        <span class="tree-text" v-text="treeItem5.title" ></span>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

export default {
    name: 'LayuiTreeselect',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-treeselect-' + window.uuid();
            },
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        _model: {
            default: null,
            required: false
        },
        textField: {
            default: 'text',
            type: String
        },
        valueField: {
            default: 'value',
            type: String
        },
        idField: {
            default: '',
            type: String
        },
        parentField: {
            default: '',
            type: String
        },
        tableName: {
            default: '',
            type: String
        },
        selectFields: {
            default: '',
            type: String
        },
        condition: {
            default: () => {
                return {}
            },
            type: Object
        },
        showCheck: {
            type: Boolean,
            default: ()=> {
                return false;
            }
        },
        initExpandLevel: {
            type: Number,
            default : 0
        },
        // 树加载到几级
        maxLoadLevel: {
            type: Number,
            default: 5,
        },
        // 选中后父级的文本也显示
        showParentLabel: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data () {
        return {
            id : null,
            el : null,
            title: null,
            showSelect : false,
            selectRow: {}, //当前选中的值
            checkRows: [],
            data: [],
            map: {},
        }
    },
    mounted() {
       var element = this.el = $(this.$el);
       var id = this.id = this.uuid();
       element.attr('id', id);
       this.api.queryList(
                    this.tableName, 
                    {p2: this.condition, p9: this.selectFields},
                    this.requestUniqueId
                ).then(response => {
            var result = response.result;
            this.data = this._arrayToTree0(result);
            this.isload = true;
            if(this._model) {
                this.handleModel(this._model);
            }
        })
    },
    methods: {
      select(row) {
          if(!this.showCheck && this.enabled) {
              this.ui_update = true;
              this.selectRow = row;
              if(this.showParentLabel) {
                  var labelArr = [row.title];
                  let p = row;
                  while(( p = p.parent) != null) {
                      labelArr.unshift(p.title);
                  }
                  this.title = labelArr.join('-');
              } else {
                  this.title = row.title;
              }
              this.$emit('_modelEvent', row.value);
              this.$emit('treeSelect', row);
          }
      },
      check(row){
        if(this.showCheck && this.enabled) {
             this.ui_update = true;
            if(!row.checked) {
                row.checked = true;
                this.checkRows.push(row);
            } else {
                row.checked = false;
                this.checkRows.remove(row);
            }
            var arr = [];
            var modelArr = [];
            for(var i = 0 ; i < this.checkRows.length; i++) {
                arr.push(this.checkRows[i].title);
                modelArr.push(this.checkRows[i].value);
            }
            this.title = arr.join(",");
            this.$emit('_modelEvent', modelArr.join(","));
            this.$emit('treeCheck', this.checkRows);
        }
      },
      decideShowSelect(){
          if(this.enabled) {
              var has = this.el.hasClass("layui-form-selected");
              if(has) {
                  this.el.removeClass("layui-form-selected");
              } else {
                  this.el.addClass("layui-form-selected");
              }
          }
      },
      expand(row){
            row.expand = !row.expand;
            if(row.expand && !row.childLoad && this.enabled){
                //根据政区级别控制，显示级别
                if(row.jb < this.maxLoadLevel){
                    this.loadChildren(row);
                } else {
                    row.isLeaf = true;
                }
            }
        },
      loadChildren(parent){
           var condition = {};
            condition[this.parentField] = parent.id;
            this.api.queryList(
                this.tableName, 
                {p2: condition, p9: this.selectFields},
                this.requestUniqueId
            ).then(response => {
                var result = response.result;
                if(result.length > 0) {
                    parent.children = [];
                    for(var i = 0 ; i < result.length; i++) {
                        var item = result[i];
                        parent.children.push(this.buildTreeData(item));
                    }
                } else {
                    parent.isLeaf = true;
                }
                parent.childLoad = true;
                this.wrap(parent.children, parent.jb + 1, parent)
            })
      },
      reset(){
            this.selectRow = {};
            if(this.checkRows.length > 0) {
                this.checkRows.forEach((e)=>{
                    e.checked = false;
                });
            }
            this.checkRows = [];
      },
      buildTreeData(item){
            var treeData = {
                id: item[this.idField],
                title: item[this.textField],
                value: item[this.valueField],
                children: [],
                _pid: item[this.parentField],
                _data: item,
                expand: false,
                checked: false,
                childLoad : false,
                isLeaf : false
            }
            return treeData;
      },
       _arrayToTree0(array){
             var rootRows = []
             var treeRows = [];
             for (var i = 0 ; i < array.length ; i++) {
                var item = array[i];
                var id = item[this.idField];
                var treeData = this.buildTreeData(item)
                this.map[id] = treeData;
                treeRows.push(treeData)
             }
             for(var j = 0 ; j < treeRows.length; j++) {
                var treeRow = treeRows[j];
                var pid = treeRow._pid;
                if(this.map[pid]) {
                    this.map[pid]['children'].push(treeRow);
                    this.map[pid].childLoad = true;
                    treeRow._p = true;
                }
             }
            for(var k = 0 ; k < treeRows.length; k++) {
                var treeRow = treeRows[k];
                if(!treeRow._p) {
                    rootRows.push(treeRow);
                }
            }
            this.wrap(rootRows, 1)
            return rootRows;
        },
        wrap(rootRows, jb, parent){
            for(var l = 0; l < rootRows.length; l++) {
                var row = rootRows[l];
                row.jb = jb;
                if(parent){
                    row.parent = parent;
                }
                if(row.jb <= this.initExpandLevel) {
                    row.expand = true;
                }
                if(row.children && row.children.length > 0) {
                    this.wrap(row.children, jb + 1);
                }
            }
        },
        getDataByValue(value){
            for(var p in this.map) {
                var item = this.map[p];
                if(item.value == value) {
                    return item;
                }
            }
        },
        handleModel(model){
            if(!this.ui_update) {
                this.title = null;
                this.selectRow = {};
                for(var k = 0; k < this.checkRows.length; k++) {
                    this.checkRows[k].checked = false;
                }
                this.checkRows = [];
                if(model) {
                    if(this.showCheck) {
                        var arr = model.split(",");
                        for(var i = 0 ; i < arr.length ; i++) {
                            var targetRow = this.getDataByValue(arr[i]);
                            targetRow.checked = true;
                            this.checkRows.push(targetRow);
                            var arr = [];
                            for(var i = 0 ; i < this.checkRows.length; i++) {
                                arr.push(this.checkRows[i].title);
                            }
                            this.title = arr.join(",");
                        }
                    } else {
                        var modelVal = model.split(',')[0];
                        this.selectRow = this.getDataByValue(modelVal);
                        if(!this.selectRow) {
                            // 如果已经加载的数据集中找不到model中对应的值，那该怎么办？？
                            // 我们去查，先把title的值找出来
                            // var condition = {};
                            // condition[this.valueField] = modelVal;
                            // this.api.queryOne( 
                            //     this.tableName, 
                            //     { p2: condition, p9: this.selectFields},
                            //     this.requestUniqueId)
                            // .then(response => {
                            //    if(response.result) {
                            //        this.selectRow = this.buildTreeData(response.result);
                            //        this.title = this.selectRow.title;
                            //    } 
                            // });
                        } else {
                            this.title = this.selectRow.title;
                        }
                    }
                }
            } 
            this.ui_update = false;
            
        }
    },
    watch:{
        _model(value){
            if(this.isload) {
                this.handleModel(value);
            }
        }
    }
  }

</script>
<style scoped>


.layui-form-select .layuitreeselect-items {
    display: none;
    position: absolute;
    left: 0;
    top: 42px;
    padding: 5px 0;
    z-index: 899;
    min-width: 100%;
    border: 1px solid #d2d2d2;
    max-height: 300px;
    overflow-y: auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 4px rgba(0,0,0,.12);
    box-sizing: border-box
}

.layui-form-select .layuitreeselect-items .layuitreeselect-item {
    line-height: 36px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
     cursor: pointer
}

.layui-form-select .layuitreeselect-items .layuitreeselect-item:hover {
    background-color: #f2f2f2;
    -webkit-transition: .5s all;
    transition: .5s all
}


.layui-form-select .layuitreeselect-items .layuitreeselect-item.layui-select-tips {
    padding-left: 10px!important;
    color: #999
}

.layui-form-select  .layui-this {
    background-color: #1c92e6;
    color: #fff
}

.layui-form-select .layuitreeselect-items .layuitreeselect-item.layui-this:hover {
    background-color: #1c92e6;
    color: #fff
}

.layui-form-select .layuitreeselect-items .layuitreeselect-item.layui-disabled {
    background-color: #fff
}

.layui-form-selected .layuitreeselect-items{
    display: block
}

</style>


// WEBPACK FOOTER //
// src/components/common/LayuiTreeSelect.vue